import { createSlice } from '@reduxjs/toolkit'
import { ActionPayload } from '@shared/types'
import { Auth, User } from './types'

interface UserSliceState {
    auth?: Auth
    user?: User
}
const initialState: UserSliceState = {}

export const userSlice = createSlice({
  name: 'user-slice',
  initialState,
  reducers: {
    login: (state, {payload}: ActionPayload<Auth>) => {
        if(payload == undefined) return
        
        state.auth = payload
    },
    logout: (state) => {
        state.auth = undefined
    },
    setUser: (state, {payload}: ActionPayload<User>) => {
        state.user = payload
    }
  }
})

export const { 
    login,
    logout,
    setUser
} = userSlice.actions
